export const ISR_TIMEOUT = process.env.ENV === 'production' ? 300 : 10;

export const THEMES = {
  FOOD: 'FOOD',
  HOUSING: 'HOUSING',
  FACTORIES: 'FACTORIES',
  ROADS: 'ROADS',
  WATER: 'WATER',
  MILITARY: 'MILITARY',
};

export const INTRODUCTION_CHAPTERS = [
  'foodIntroduction',
  'housingIntroduction',
  'factoriesIntroduction',
  'roadsIntroduction',
  'waterIntroduction',
  'militaryIntroduction',
];

export const THEME_CHAPTERS = {
  FOOD: {
    INTRODUCTION: 'foodIntroduction',
    GRAIN_STORAGE_CELLARS: 'grainStorageCellars',
    WINE: 'wine',
    MEAT: 'meat',
    STORAGE_HOUSES_AND_RECORDS: 'storehousesAndRecords',
  },
  HOUSING: {
    INTRODUCTION: 'housingIntroduction',
    BUILDING_MATERIALS: 'buildingMaterials',
    FLOOR_PLANS: 'floorPlans',
    PLUMBING: 'plumbing',
    WAY_STATION_OFFICER: 'wayStationOfficer',
  },
  FACTORIES: {
    INTRODUCTION: 'factoriesIntroduction',
    KILN_TECHNOLOGY: 'kilnTechnology',
    JADE_WORKSHOP: 'jadeWorkshop',
    BRONZE_FOUNDRIES: 'bronzeFoundries',
    TRADERS: 'traders',
  },
  ROADS: {
    INTRODUCTION: 'roadsIntroduction',
    CONSTRUCTIONS: 'constructions',
    VEHICLES: 'vehicles',
    BRIDGES: 'bridges',
    INFRASTRUCTURE: 'infrastructure',
  },
  WATER: {
    INTRODUCTION: 'waterIntroduction',
    CANALS: 'canals',
    WELLS: 'wells',
    PALACE_RESERVOIR: 'palaceReservoir',
    BOAT_OFFICER: 'boatOfficer',
  },
  MILITARY: {
    INTRODUCTION: 'militaryIntroduction',
    SACRIFICAL_BURIALS: 'sacrificalBurials',
    MILITARY_LEADERS: 'militaryLeaders',
    VICTIMS: 'victims',
    CAMPAING_OFFICERS: 'campaignOfficers',
  },
};
